import { AxiosPromise } from 'axios';
import { ApiIntegrationType } from '../../enums/ApiIntegrationType';
import { libApiInstance } from '../axios';
import { IntegrationApiResponse } from './types/IntegrationApiResponse';

export function requestIntegrations(signal?: AbortSignal): AxiosPromise<IntegrationApiResponse[]> {
    return libApiInstance.get(`/config/integrations/api`, { signal });
}

export function requestRegenerateIntegrationKey(
    sourceId: ApiIntegrationType,
    signal?: AbortSignal,
): AxiosPromise<IntegrationApiResponse> {
    return libApiInstance.put(`/config/integrations/api/${sourceId}`, {
        signal,
    });
}

export function requestCreateIntegration(
    sourceId: ApiIntegrationType,
    signal?: AbortSignal,
): AxiosPromise<IntegrationApiResponse> {
    return libApiInstance.post(`/config/integrations/api/${sourceId}`, { signal });
}
